<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <b-card class="card-diagnostic">
          <template #header>
            <strong class="mb-0"> Caracterización</strong>
          </template>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <b-row class="w-50">
              <b-col cols="12" class="mb-4">
                <SelectSearch
                  label="Grupo de Diagnóstico"
                  name="name"
                  :options="optionsGroup"
                  :value="formData.group_diagnostic"
                  :required="true"
                  :loading="loadingGroup"
                  :disabled="isEdit || isBusy"
                  @input="onSelect"
                  @search="searchGroup"
                />
              </b-col>
              <b-col cols="12" class="mb-4">
                <SelectSearch
                  label="Diagnóstico"
                  name="name"
                  :options="optionsDiagnostic"
                  :value="formData.diagnostic"
                  :required="true"
                  :loading="loadingDiagnostic"
                  :disabled="isEdit || isBusy"
                  @input="onSelectDiagnostic"
                  @search="searchDiagnostic"
                />
              </b-col>
              <b-col cols="12" class="mb-4">
                <Select
                  label="Tipo de SVE"
                  name="risk"
                  v-model="formData.risk"
                  :options="optionsTypeSVE"
                  :value="formData.risk"
                  :required="true"
                  :disabled="isEdit || isBusy || optionsGroup.length === 0"
                />
              </b-col>
              <b-col cols="12" class="mb-4">
                <Select
                  label="Lateralidad"
                  name="laterality"
                  v-model="formData.laterality"
                  :options="optionsLateralidad"
                  :value="formData.laterality"
                  :required="true"
                  :disabled="isEdit || isBusy || optionsGroup.length === 0"
                />
              </b-col>
            </b-row>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import useInputs from "@/components/general/Inputs";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
const { Select, SelectSearch } = useInputs();
import {
  getGroupDiagnostics,
  getDiagnosticsById,
} from "@/services/health-tracker/diagnostic/service";
export default {
  components: {
    Select,
    SelectSearch,
    OverlayButton,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      optionsGroup: [],
      optionsDiagnostic: [],
      optionsTypeSVE: [],
      optionsLateralidad: [
        {
          id: "right",
          name: "Derecho",
        },
        {
          id: "left",
          name: "Izquierdo",
        },
        {
          id: "bilateral",
          name: "Bilateral",
        },
        { 
          id: "not_applicable",
          name: "No aplica",
        }
      ],
      formData: {
        group_diagnostic: null,
        diagnostic: null,
        risk: null,
        laterality: null,
      },
      loadingGroup: false,
      loadingDiagnostic: false,
      abortController: null,
      abortControllerDiagnostic: null,
    };
  },
  watch: {
    formData: {
      handler() {
        this.$emit("changeForm", this.formData);
      },
      deep: true,
    },
    record() {
      const me = this;
      if (me.record) {
        me.fillData();
      }
    },
  },
  computed: {
    ...mapState("modSVE", ["sveList"]),
  },
  methods: {
    ...mapActions("modSVE", ["actGetSVElist"]),
    listSVE() {
      const me = this;
      me.actGetSVElist().then(() => {
        me.sveList.map((x) => {
          me.optionsTypeSVE.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },
    onSelect(value) {
      const me = this;
      me.formData.group_diagnostic = value;
      me.formData.diagnostic = null;
      me.optionsDiagnostic = [];
      me.loadDiagnosticsById(value?.id);
    },
    onSelectDiagnostic(value) {
      const me = this;
      me.formData.diagnostic = value;
    },
    async loadDiagnosticsGroup(params = "") {
      const me = this;
      me.loadingGroup = true;
      me.optionsGroup = [];
      me.optionsDiagnostic = [];
      me.formData.group_diagnostic = null;
      me.formData.diagnostic = null;

      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      
      try {
        const { data } = await getGroupDiagnostics({q: params}, signal);
        data?.forEach((x) => {
          me.optionsGroup.push({
            id: x.id,
            name: x.code_name,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingGroup = false;
      }
    },
    async loadDiagnosticsById(id, params = "") {
      const me = this;
      me.loadingDiagnostic = true;
      me.optionsDiagnostic = [];

      if (me.abortControllerDiagnostic) {
        me.abortControllerDiagnostic.abort(); // Cancela la petición anterior
      }

      me.abortControllerDiagnostic = new AbortController();
      const signal = me.abortControllerDiagnostic.signal;

      try {
        const { data } = await getDiagnosticsById(id, {q: params}, signal);
        data?.forEach((x) => {
          me.optionsDiagnostic.push({
            id: x.id,
            name: x.code_name,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingDiagnostic = false;
      }
    },
    async fillData() {
      const me = this;
      me.formData.laterality = me.optionsLateralidad.find(
        (x) => x.id === me.record.laterality
      );
      me.formData.risk = me.sveList.find((x) => x.id === me.record.risk_id);
      await me.loadDiagnosticsById(me.record?.diagnostic?.type_list_id);
      me.formData.group_diagnostic = me.optionsGroup.find(
        (x) => x.id === me.record?.diagnostic?.type_list_id
      );
      me.formData.diagnostic = me.optionsDiagnostic.find(
        (x) => x.id === me.record?.diagnostic_id
      );
    },
    searchGroup(value) {
      const me = this;
      me.loadDiagnosticsGroup(value);
    },
    searchDiagnostic(value) {
      const me = this;
      me.loadDiagnosticsById(me.formData.group_diagnostic?.id, value);
    },
  },
  mounted() {
    const me = this;
    me.loadDiagnosticsGroup();
    me.listSVE();
  },
};
</script>

<style lang="css">
.card-diagnostic .card-header {
  background: #f5f5f5 !important;
}
</style>
